import { createAsyncThunk } from '@reduxjs/toolkit';

import { authSet } from '../../../utils/request';
import { METHOD_POST } from '../../../constants/api';
import { setCreateNewOrderData } from '../../coilovers/orders/createNewOrder';

const postEasyShipBuyShipment = createAsyncThunk('postEasyShipBuyShipment/postEasyShipBuyShipment',
  async (formData, { rejectWithValue, dispatch }) => {
    try {
      const data = await authSet(METHOD_POST, '/shipping/easyship/buy', formData);
      dispatch(setCreateNewOrderData({
        order_label_file: data?.s3_label_url || '',
        order_shipment_tracking_number: data?.tracking_code || '',
        order_assembly_invoice: data?.s3_invoice_url || '',
      }));
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  });

export default postEasyShipBuyShipment;
